import {Product} from './Product';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransfer} from './ContractItemTransfer';
import {ContractItemType} from './ContractItemType';
import {Contract} from './Contract';
import {Availability} from './Availability';
import {BaseObject} from './BaseObject';
import {ProductContractItem} from './ProductContractItem';

export abstract class ContractItem extends BaseObject {
    id: number;
    contractId: number;

    name = '';
    count = 1;
    lentCount = 0;
    hirePrice = 0;
    lossPrice = 0;
    sale = 0;
    vat = VatRateService.VAT21;

    days = 1;
    daysChanged = false;

    order = 0;
    type: ContractItemType = ContractItemType.other;

    dispatched = 0;
    returned = 0;
    lost = 0;

    isSell = false;
    isWrap = false;
    isLoss = false;

    availability: Availability = new Availability();

    setContract = (c: Contract): void => {
        this.contractId = c.id;
    }

    getHirePriceAfterSale = (): number => {
        return (this.hirePrice) * (1 - (this.sale / 100));
    }

    getTotalPrice = (): number => {
        // do not charge wraps and losses
        if (this.isWrap || this.isLoss) {
            return 0;
        }

        return (this.hirePrice * this.lentCount) * (1 - (this.sale / 100));
    }

    getVat = (): number => {
        return (this.vat / 100) * this.getTotalPrice();
    }

    getTotalVatPrice = (): number => {
        // return ((100 + this.vat) / 100) * this.hirePrice * this.count;
        return this.getTotalPrice() + this.getVat();
    }

    isDelivery = (): boolean => {
        return this.type === ContractItemType.delivery;
    }

    isDeployment = (): boolean => {
        return this.type === ContractItemType.deployment;
    }

    isOther = (): boolean => {
        return this.type === ContractItemType.other;
    }

    isText = (): boolean => {
        return this.type === ContractItemType.text;
    }

    isGroup = (): boolean => {
        return this.type === ContractItemType.group;
    }

    isProductOrGroup = (): boolean => {
        return this.type === ContractItemType.product
            || this.type === ContractItemType.group;
    }

    isProduct = (): boolean => {
        return this.type === ContractItemType.product;
    }

    isAvailable = (): boolean | null => {
        if (this.isDelivery() || this.isDeployment() || this.isText()) {
            return null;
        }

        return this.availability.available;
    }

    setHirePrice = (p: string): void => {
        this.hirePrice = this.convertToNumber(p);
    }

    setSale = (p: string): void => {
        this.sale = this.convertToNumber(p);
    }

    setDays = (p: string, c: Contract): void => {
        this.days = this.convertToNumber(p);
        this.daysChanged = (this.days !== c.daysCount);
    }

}



// WEBPACK FOOTER //
// /app/src/model/Entities/ContractItem.ts